import { createSlice } from '@reduxjs/toolkit';
import { message, notification } from 'antd';

import { apiError } from '../../utils/notification';

const slice = createSlice({
  name: 'vendor',
  initialState: {
    submitting: false,
    loading: false,
    vendor: null,
    vendor_users: [],
    error: null,
    media_library_images: { data: [] },
    withdrawal_requests: [],
  },
  reducers: {
    getMedia: state => {
      state;
    },
    getMediaSuccess: (state, { payload }) => {
      state.media_library_images = {
        data: payload.library_images,
      };
    },
    getMediaFailed: state => {
      state;
    },
    getVendor: state => {
      state.loading = true;
      state.error = null;
    },
    getVendorSuccess: (state, { payload }) => {
      state.loading = false;
      state.vendor = payload;
      state.error = null;
    },
    getVendorFailed: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      apiError(payload);
    },
    getVendorUsers: state => {
      state.loading = true;
      state.error = null;
    },
    getVendorUsersSuccess: (state, { payload }) => {
      state.loading = false;
      state.vendor_users = payload?.vendor_users;
      state.error = null;
    },
    getVendorUsersFailed: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      apiError(payload);
    },
    createUser: state => {
      state.submitting = true;
      state.error = null;
      state.message = message.loading('Adding a new worker ...', 0);
    },
    createUserSuccess: (state, { payload }) => {
      state.message();
      state.submitting = false;
      state.vendor_users = payload?.vendor_users;
      state.error = null;
      notification.success({
        message: 'New Worker',
        description: `New Worker has been added.`,
      });
    },
    createUserFailed: (state, { payload }) => {
      state.message();
      state.submitting = false;
      state.error = payload;
      apiError(payload);
    },
    updateUser: state => {
      state.submitting = true;
      state.error = null;
      state.message = message.loading('Updating vendor info...', 0);
    },
    updateUserSuccess: (state, { payload }) => {
      state.message();
      state.submitting = false;
      state.loading = false;
      state.vendor_users = payload?.vendor_users;
      state.error = null;
      notification.success({
        message: 'Worker Updated',
        description: `Worker has been updated successfully.`,
      });
    },
    updateUserFailed: (state, { payload }) => {
      state.message();
      state.submitting = false;
      state.error = payload;
      apiError(payload);
    },
    deleteUser: state => {
      state.message = message.loading('Deleting vendor user ...', 0);
      state.error = null;
      state.loading = true;
    },
    deleteUserSuccess: (state, { payload }) => {
      state.message();
      state.vendor_users = state.vendor.vendor_users.filter(
        x => x.id !== payload['vendor_user'].id
      );
      state.error = null;
      notification.success({
        message: 'Delete Vendor User',
        description: `Vendor User ${payload['vendor_user'].first_name} ${payload['vendor_user'].last_name} has been deleted.`,
      });
    },
    deleteUserFailed: (state, { payload }) => {
      state.message();
      state.error = payload;
      apiError(payload);
    },
    getWithdrawals: state => {
      state.loading = true;
    },
    getWithdrawalsSuccess: (state, { payload }) => {
      state.loading = false;
      state.meta = payload['meta'];
      state.withdrawal_requests = payload['withdrawal_requests'];
    },
    getWithdrawalsFailed: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      apiError(payload);
    },
    withdrawalRequestAction: state => {
      state.loading = true;
    },
    withdrawalRequestActionSuccess: (state, { payload }) => {
      state.loading = false;
      state.meta = payload['meta'];
      let requests = [...state.withdrawal_requests];
      requests = requests.map(req => {
        if (req.id === payload['withdrawal_request'].id) {
          return {
            ...payload['withdrawal_request'],
          };
        } else {
          return req;
        }
      });
      state.withdrawal_requests = requests;
    },
    withdrawalRequestActionFailed: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      apiError(payload);
    },
  },
});

export const {
  getMedia,
  getMediaFailed,
  getMediaSuccess,
  getVendor,
  getVendorSuccess,
  getVendorFailed,
  createUser,
  createUserSuccess,
  createUserFailed,
  updateUser,
  updateUserSuccess,
  updateUserFailed,
  deleteUser,
  deleteUserSuccess,
  deleteUserFailed,
  getWithdrawals,
  getWithdrawalsSuccess,
  getWithdrawalsFailed,
  withdrawalRequestAction,
  withdrawalRequestActionSuccess,
  withdrawalRequestActionFailed,
  getVendorUsers,
  getVendorUsersSuccess,
  getVendorUsersFailed,
} = slice.actions;

export default slice.reducer;
